export default __webpack_public_path__ + "static/media/logo.3f346d4e.png";